module.exports = "<div class=\"beta_badge\">BETA</div>\n"